import { EcommerceAPI } from "../Client";
import { appendProcessedFile } from "../../../utils/imageUploadProcessor";

export const getAllARShapesAPI = async () => {
  try {
    const response = await EcommerceAPI.get("/api/ar-shapes");
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const createARShapeAPI = async (payload) => {
  try {
    const response = await EcommerceAPI.post("/api/ar-shapes", payload);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const getARShapeAPI = async (arShapeId) => {
  try {
    const response = await EcommerceAPI.get(`/api/ar-shapes/${arShapeId || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const updateARShapeAPI = async (payload) => {
  try {
    const response = await EcommerceAPI.put(
      `/api/ar-shapes/${payload?.arShapeId || ""}`,
      payload
    );
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const deleteARShapeAPI = async (arShapeId) => {
  try {
    const response = await EcommerceAPI.delete(`/api/ar-shapes/${arShapeId || ""}`);
    return response;
  } catch (error) {
    throw error.response || error;
  }
};

export const uploadARShapeFileAPI = async ({ arShapeId, file }) => {
  try {
    const formData = new FormData();
    await appendProcessedFile(formData, "file", file);

    const response = await EcommerceAPI.post(`/api/ar-shapes/${arShapeId || ""}/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    throw error.response || error;
  }
};
